<template>
    This is the home page.
</template>

<script setup>
</script>
